export default {
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    isXlViewport() {
      return this.$vuetify.breakpoint.name === 'xl';
    },

    isMdOrLargerViewport() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm': return false;
        default: return true;
      }
    },

    isXsViewport() {
      return this.$vuetify.breakpoint.name === 'xs';
    },

    isMenuDrawerClosable() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xl': {
          return false;
        }
        default: {
          return true;
        }
      }
    },
  },
};
